import React, { useState, useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
    obtenerMetodosPagoPersonalizados,
    crearMetodoPagoPersonalizado,
    actualizarMetodoPagoPersonalizado,
    eliminarMetodoPagoPersonalizado
} from '../../services/ConfiguracionServicio';

const AdministradorMetodosPago = () => {
    const [metodos, setMetodos] = useState([]);
    const [nombreNuevo, setNombreNuevo] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [guardando, setGuardando] = useState(false);

    useEffect(() => {
        cargarMetodos();
    }, []);

    const cargarMetodos = async () => {
        setIsLoading(true);
        try {
            const data = await obtenerMetodosPagoPersonalizados();
            setMetodos(Array.isArray(data) ? data : []);
        } catch (err) {
            toast.error('Error de conexión');
        } finally {
            setIsLoading(false);
        }
    };

    const handleAgregar = async (e) => {
        e.preventDefault();
        const nombre = nombreNuevo.trim();
        if (!nombre) return;
        setGuardando(true);
        try {
            const res = await crearMetodoPagoPersonalizado(nombre);
            if (res.error) {
                toast.error(res.error);
            } else {
                toast.success('Método de pago agregado');
                setNombreNuevo('');
                cargarMetodos();
            }
        } catch (err) {
            toast.error('No se pudo guardar');
        } finally {
            setGuardando(false);
        }
    };

    const handleToggleActivo = async (m) => {
        try {
            await actualizarMetodoPagoPersonalizado(m.id, { activo: m.activo ? 0 : 1 });
            cargarMetodos();
        } catch (err) {
            toast.error('No se pudo actualizar');
        }
    };

    const handleEliminar = async (m) => {
        if (!window.confirm(`¿Eliminar el método de pago "${m.nombre}"?`)) return;
        try {
            await eliminarMetodoPagoPersonalizado(m.id);
            toast.success('Eliminado');
            cargarMetodos();
        } catch (err) {
            toast.error('No se pudo eliminar');
        }
    };

    return (
        <div className="bg-light min-vh-100 py-5 px-3">
            <ToastContainer position="bottom-center" autoClose={2500} hideProgressBar />
            <div className="container" style={{ maxWidth: '700px' }}>
                <div className="mb-4">
                    <h1 className="h2 font-weight-bold text-dark mb-1">Métodos de Pago Personalizados</h1>
                    <p className="text-muted">
                        Agrega medios de pago propios (ej: un sistema de tarjetas externo) para usarlos en el TPV
                        desde el botón <strong>"Otros"</strong>. Se suman a Efectivo, Débito, Crédito y Transferencia.
                    </p>
                </div>

                <div className="card border-0 shadow-sm rounded-xl mb-4">
                    <div className="card-body p-4">
                        <form onSubmit={handleAgregar} className="d-flex gap-2">
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Ej: Tarjetas Sistema X"
                                value={nombreNuevo}
                                onChange={(e) => setNombreNuevo(e.target.value)}
                                maxLength={50}
                            />
                            <button type="submit" className="btn btn-primary font-weight-bold px-4" disabled={guardando || !nombreNuevo.trim()}>
                                {guardando ? 'Guardando...' : 'Agregar'}
                            </button>
                        </form>
                    </div>
                </div>

                <div className="card border-0 shadow-sm rounded-xl overflow-hidden">
                    <div className="card-body p-0">
                        {isLoading ? (
                            <div className="text-center py-5"><div className="spinner-border text-primary"></div></div>
                        ) : metodos.length === 0 ? (
                            <div className="text-center py-5 text-muted">Aún no has agregado métodos de pago personalizados.</div>
                        ) : (
                            <table className="table table-hover align-middle mb-0">
                                <tbody>
                                    {metodos.map(m => (
                                        <tr key={m.id}>
                                            <td className="px-4 py-3 font-weight-bold text-dark">{m.nombre}</td>
                                            <td className="py-3 text-center" style={{ width: '140px' }}>
                                                <span className={`badge px-3 py-2 rounded-pill ${m.activo ? 'badge-soft-success' : 'badge-soft-secondary'}`} style={{ cursor: 'pointer' }} onClick={() => handleToggleActivo(m)}>
                                                    {m.activo ? 'Habilitado' : 'Deshabilitado'}
                                                </span>
                                            </td>
                                            <td className="px-4 py-3 text-right" style={{ width: '60px' }}>
                                                <button className="btn btn-icon btn-light rounded-circle text-danger" onClick={() => handleEliminar(m)} title="Eliminar">
                                                    <i className="fas fa-trash"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        )}
                    </div>
                </div>
            </div>

            <style>{`
                .rounded-xl { border-radius: 1.25rem !important; }
                .badge-soft-success { background-color: #e6fcf5; color: #087f5b; }
                .badge-soft-secondary { background-color: #f1f3f5; color: #495057; }
                .btn-icon { width: 36px; height: 36px; border: none; display: inline-flex; align-items: center; justify-content: center; transition: 0.2s; }
                .btn-icon:hover { background-color: #e9ecef; transform: scale(1.1); }
            `}</style>
        </div>
    );
};

export default AdministradorMetodosPago;
